import { pick } from 'lodash'

const transformToUpdateDietCategoryDetailsArgs = data =>
  pick(data, ['description', 'position', 'isMain'])

export default transformToUpdateDietCategoryDetailsArgs
